import { render, staticRenderFns } from "./recordingGuide.vue?vue&type=template&id=47c63b17&scoped=true"
import script from "./recordingGuide.vue?vue&type=script&lang=js"
export * from "./recordingGuide.vue?vue&type=script&lang=js"
import style0 from "./recordingGuide.vue?vue&type=style&index=0&id=47c63b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c63b17",
  null
  
)

export default component.exports